const convertImageToDataUrl = (image) =>
  new Promise((resolve) => {
    const imageUrl = image instanceof File ? URL.createObjectURL(image) : image;
    const canvas = document.createElement('canvas');
    const img = new Image();

    img.onload = function () {
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;

      const context = canvas.getContext('2d');
      context.drawImage(this, 0, 0);

      resolve(canvas.toDataURL('image/png'));
    };

    img.src = imageUrl;
  });

window.convertImageToDataUrl = convertImageToDataUrl;

export default convertImageToDataUrl;
